import { TRANSLATIONS } from './translations';
import { HeavyDutyMachineryOption } from './heavyDutyMachinerySpaceOptions';

// The "Nivel A" global attributes from the Yémin/Gemini technical spec --
// apply to ~95% of the catalog, stay as real Machinery columns (not the
// per-type CustomAttributesJson blob, see machineryCustomSpecFieldsByType.ts)
// so the map could filter on them later, even though this round only wires
// them into the create/edit form + detail page, not FiltersModal -- Peso/
// Potencia/Categoría already cover the map's own filtering needs per
// Yémin's own "80/20" recommendation.
export const PROPULSION_TYPE_OPTIONS: HeavyDutyMachineryOption[] = [
  { value: 'SteelTracks', labelKey: TRANSLATIONS.MACHINERY_SPEC_PROPULSION_STEEL_TRACKS },
  { value: 'RubberTracks', labelKey: TRANSLATIONS.MACHINERY_SPEC_PROPULSION_RUBBER_TRACKS },
  { value: 'Wheels', labelKey: TRANSLATIONS.MACHINERY_SPEC_PROPULSION_WHEELS },
  { value: 'Stationary', labelKey: TRANSLATIONS.MACHINERY_SPEC_PROPULSION_STATIONARY },
];

export const FUEL_TYPE_OPTIONS: HeavyDutyMachineryOption[] = [
  { value: 'Diesel', labelKey: TRANSLATIONS.MACHINERY_SPEC_FUEL_DIESEL },
  { value: 'Electric', labelKey: TRANSLATIONS.MACHINERY_SPEC_FUEL_ELECTRIC },
  { value: 'Hybrid', labelKey: TRANSLATIONS.MACHINERY_SPEC_FUEL_HYBRID },
  { value: 'Gasoline', labelKey: TRANSLATIONS.MACHINERY_SPEC_FUEL_GASOLINE },
];
